module.exports = __webpack_public_path__ + "img/tool-diamond.e147c703.svg";